module.exports = __webpack_public_path__ + "img/avatar.ee34a41d.png";